import React, { Fragment, useState, useEffect } from 'react'
import NormalQuestion from './NormalQuestion'
import QnaFirst from './QnaFirstQuiz';
import QnaLast from './QnaLastQuiz';
import QnaResponse from './QnaResponseQuiz';
//import questions from './mock.json';
import questions from './finnfitqnaQuiz.json';
import finnfitqnaQuiz55 from './finnfitqnaQuiz55.json';
import SideImg from '../../img/BasicProfile.png';

export default function QnaQuiz() {


  //eslint-disable-next-line
  const [questionIndex, setQuestionIndex] = useState(1);
  const [userSlectedAns, setUserSlectedAns] = useState(null);
  const [userSlectedWeight, setUserSlectedWeight] = useState(null);
  const [questionsAndAnswers, setQuestionsAndAnswers] = useState([]);

  const [finAge, setFinAge] = useState(54);

  /*const handleNext = (ans_id, ques_id, ques_title, weight, category, condition) => {


    console.log('ans_d', ans_id, 'ques_id', ques_id, 'ques_title', ques_title, 'weight', weight, 'category', category, 'condition', condition);

    setQuestionIndex(questionIndex + 1);
    setUserSlectedAns(ans_id);
    setUserSlectedWeight(weight);

    const qna = questionsAndAnswers;
    qna.push({
      id: questions[questionIndex - 1].id,
      user_answer: ans_id,
      category: category
    });

    setUserSlectedAns(null);
    setUserSlectedWeight(null);
    setQuestionsAndAnswers(qna);

    if (questionIndex === 13) {
      setSteps(3);
      sessionStorage.setItem("QnaJson", JSON.stringify(questionsAndAnswers))
      return;
    }

  }*/


  /*const handleNext = (ans_id, ques_id, ques_title, weight, category, condition) => {


    console.log('ans_d', ans_id, 'ques_id', ques_id, 'ques_title', ques_title, 'weight', weight, 'category', category, 'condition', condition);

    const currentQuestion = filteredQuestions[questionIndex - 1];

    const newQnA = {
      id: currentQuestion?.id || ques_id,
      user_answer: ans_id,
      category: category,
    };

    setQuestionsAndAnswers(prev => [...prev, newQnA]);
    setUserSlectedAns(null);
    setUserSlectedWeight(null);

    if (questionIndex === filteredQuestions.length) {
      sessionStorage.setItem("QnaJson", JSON.stringify([...questionsAndAnswers, newQnA]));
      setSteps(3);
      return;
    }

    setQuestionIndex(prev => prev + 1);
  };*/


  /*const handleNext = (ans_id, ques_id, ques_title, weight, category, condition) => {
    const currentQuestion = filteredQuestions[questionIndex - 1];

    const newQnA = {
      id: currentQuestion?.id || ques_id,
      user_answer: ans_id,
      category: category,
    };

    const updatedQnA = [...questionsAndAnswers, newQnA];

    setQuestionsAndAnswers(updatedQnA);
    setUserSlectedAns(null);
    setUserSlectedWeight(null);

    // Move to the next question directly (no skip logic)
    const nextIndex = questionIndex;

    if (nextIndex >= filteredQuestions.length) {
      sessionStorage.setItem("QnaJson", JSON.stringify(updatedQnA));
      setSteps(3);
      return;
    }

    setQuestionIndex(nextIndex + 1);
  };*/

  // eslint-disable-next-line
  const [skippedQuestionIds, setSkippedQuestionIds] = useState([]);


  const handleNext = (ans_id, ques_id, ques_title, weight, category, condition) => {
    const currentQuestion = filteredQuestions[questionIndex - 1];

    const newQnA = {
      id: currentQuestion?.id || ques_id,
      user_answer: ans_id,
      category: category,
    };

    let updatedQnA = [...questionsAndAnswers, newQnA];

    const isNoHealthInsurance =
      currentQuestion?.key === "family_health_cover" &&
      ans_id === "family_health_cover_4";

    const isNoLifeInsurance =
      currentQuestion?.key === "term_life_cover" &&
      ans_id === "term_life_cover_4";

    if (isNoHealthInsurance) {
      // Auto-fill answers for question_id 3 and 4
      const skippedQnA1 = {
        id: 3,
        user_answer: "health_insurance_expense_cover_4",
        category: "RiskManagement",
      };
      const skippedQnA2 = {
        id: 4,
        user_answer: "health_insurance_type_4",
        category: "RiskManagement",
      };
      updatedQnA.push(skippedQnA1, skippedQnA2);
      setSkippedQuestionIds(prev => [...prev, 2, 3]);

      setQuestionsAndAnswers(updatedQnA);
      setUserSlectedAns(null);
      setUserSlectedWeight(null);

      const nextIndex = questionIndex + 2;

      if (nextIndex >= filteredQuestions.length) {
        sessionStorage.setItem("QnaJson", JSON.stringify(updatedQnA));
        setSteps(3);
        return;
      }

      setQuestionIndex(nextIndex + 1);
      return;
    } else if (isNoLifeInsurance) {

      const skippedQnA3 = {
        id: 6,
        user_answer: "monthly_saving_4", // optionally change this if desired
        category: "BudgetingTaxation",
      };

      updatedQnA.push(skippedQnA3);

      setSkippedQuestionIds(prev => [...prev, 5]);

      setQuestionsAndAnswers(updatedQnA);
      setUserSlectedAns(null);
      setUserSlectedWeight(null);

      const nextIndex = questionIndex + 1;

      if (nextIndex >= filteredQuestions.length) {
        sessionStorage.setItem("QnaJson", JSON.stringify(updatedQnA));
        setSteps(3);
        return;
      }

      setQuestionIndex(nextIndex + 1); // Skip 1 question (Q6)
      return;
    } else {
      // Cleanup skippedQuestionIds for 2, 3, and 6 if not skipped anymore
      setSkippedQuestionIds(prev =>
        prev.filter(id => id !== 2 && id !== 3 && id !== 5)
      );
    }

    // Regular flow
    setQuestionsAndAnswers(updatedQnA);
    setUserSlectedAns(null);
    setUserSlectedWeight(null);

    const nextIndex = questionIndex;

    if (nextIndex >= filteredQuestions.length) {
      sessionStorage.setItem("QnaJson", JSON.stringify(updatedQnA));
      setSteps(3);
      return;
    }

    setQuestionIndex(nextIndex + 1);
  };



  const prevClick = () => {
    if (questionIndex <= 1) return;

    let newIndex = questionIndex - 1;

    // Skip dynamically based on skippedQuestionIds
    while (
      newIndex > 0 &&
      skippedQuestionIds.includes(filteredQuestions[newIndex - 1]?.id)
    ) {
      newIndex -= 1;
    }

    setQuestionIndex(newIndex);
    setUserSlectedAns(null);
    setUserSlectedWeight(null);
  };


  /*const prevClick = () => {
    if (questionIndex <= 1) return;

    let newIndex = questionIndex - 1;

    // Fetch answers from stored Q&A
    const answerQ2 = questionsAndAnswers.find(q => q.id === 2)?.user_answer;
    const answerQ3 = questionsAndAnswers.find(q => q.id === 3)?.user_answer;

    // IDs to skip when going backward
    const shouldSkipQ2 = answerQ2 === "health_insurance_expense_cover_3";
    const shouldSkipQ3 = answerQ3 === "health_insurance_type_4";

    // Loop backward until we find a non-skipped question
    while (newIndex > 0) {
      const currentQ = filteredQuestions[newIndex - 1];

      if (
        (currentQ.id === 2 && shouldSkipQ2) ||
        (currentQ.id === 3 && shouldSkipQ3)
      ) {
        newIndex -= 1;
      } else {
        break;
      }
    }

    setQuestionIndex(newIndex);
    setUserSlectedAns(null);
    setUserSlectedWeight(null);
  };*/


  const [filteredQuestions, setFilteredQuestions] = useState([]);

  /*useEffect(() => {
    const filtered = questions.filter(question => {
      const condition = question.condition || {};
      if (condition.age === true && parseInt(condition.age_limit) < finAge) {
        return false;
      }
      return true;
    });
    setFilteredQuestions(filtered);
    setQuestionIndex(1); // start at 1 for UI
  }, [finAge]);*/

  useEffect(() => {

    const source = finAge >= 55 ? finnfitqnaQuiz55 : questions;

    const filtered = source.filter(question => {
      const condition = question.condition || {};
      const ageLimit = parseInt(condition.age_limit);

      if (condition.age === true) {
        if (finAge >= 55) {
          // Include only if age_limit is 99
          return ageLimit === 99;
        } else {
          // Include only if age_limit is less than 55
          return ageLimit <= 55;
        }
      }

      // No age condition; include
      return true;
    });


    setFilteredQuestions(filtered);
    setQuestionIndex(1);
  }, [finAge]);



  /*const questionList = questions.filter(question =>
    question.itemId.toString() === questionIndex.toString()
  ).map((question) => {
    return <NormalQuestion question={question} setUserSlectedAns={setUserSlectedAns} setUserSlectedWeight={setUserSlectedWeight} userSlectedAns={userSlectedAns} userSlectedWeight={userSlectedWeight} handleNext={handleNext} />
  })*/



  const currentQuestion = filteredQuestions[questionIndex - 1];

  const questionList = currentQuestion ? (
    <NormalQuestion
      key={currentQuestion.id}
      question={currentQuestion}
      setUserSlectedAns={setUserSlectedAns}
      setUserSlectedWeight={setUserSlectedWeight}
      userSlectedAns={userSlectedAns}
      userSlectedWeight={userSlectedWeight}
      handleNext={handleNext}
    />
  ) : null;

  const [steps, setSteps] = useState(1);


  return (


    <Fragment>

      <div className="innercontainer mb40">

        {steps === 1 && (<QnaFirst steps={steps} setSteps={setSteps} setFinAge={setFinAge} />)}
        {steps === 3 && (<QnaLast steps={steps} setSteps={setSteps} finAge={finAge}/>)}
        {steps === 4 && (<QnaResponse steps={steps} setSteps={setSteps} />)}
        {steps === 2 && (
          <>
            <div className="mainwrapper">
              <div className='form_title'>
                <div className="mt30 font20 fw600">FinnFit Quiz </div>
                <div className="font15 color495">Few questions to understand your Financial Fitness Score</div>
              </div>
              <div className="row formWpr mt25">
                <div className="col-lg-8 formouter">
                  <ul className="form_swipe_tab font12 fw600">
                    <li>{questionIndex}</li>
                    { /*<li className="act">1</li>
                    <li>2</li>*/ }
                  </ul>
                  <div className="formtitle flex_center justify_center">
                    <div>
                      <div className="font20 fw600">Know your Financial Fitness Score</div>
                      <div className="font15 color495 ">Participate in the Quiz to Win your complimentary 30 Minute Session</div>
                    </div>
                    <div className='d-none d-md-block'>
                      {questionIndex > 1 && <input type="button" className="bluebtn font13 fw600 mr-3" onClick={prevClick} value="Prev" />}
                      {/*<input type="button" className="bluebtn font13 fw600 mr-3" onClick={handleNext} value="Next" disabled={!userSlectedAns} />*/}
                    </div>
                  </div>
                  {/* Form */}
                  <div className="p35">
                    <form className="custome_form">
                      {questionList}
                    </form>
                  </div>
                  {/* Form End */}
                </div>
                <div className="col-lg-4 qouteouter d-none d-md-block">
                  <div className="qoutetext font18 fw500 color212 pl45 pr45">
                    <div className="qoutesign">
                      &#8220;
                    </div>
                    Don’t worry about enclosing PAN details to finnovate. Your details will be secure and encrypted.
                  </div>
                  <div className="qouteimg"><img src={SideImg} alt='Completed' /></div>
                </div>
              </div>
              <div className="saveBtn backsaveBtn d-block d-sm-none">
                {questionIndex > 1 && <button type="button" className="btn btn-primary" onClick={prevClick}>Prev </button>}
                {/*<button type="button" className="btn btn-primary" onClick={handleNext} disabled={!userSlectedAns} >Next </button>*/}
              </div>
            </div>

            <div className="row mt50">
              <div className="col-lg-12">

                <p className='font11'>Disclaimer:</p>

                <p className='font11'>This financial fitness score is provided for educational and informational purposes only and is not intended to provide investment, tax, or legal advice. The score is calculated based on the information you provide and is not a guarantee of future performance or success. Your personal financial situation is unique, and the score may not reflect your true financial health. It is important to seek professional advice before making any financial decisions. The score is not a substitute for professional judgment and is subject to change without notice. The provider of this score assumes no responsibility for any errors or omissions in the information provided. By using this score, you agree to hold harmless the provider and its affiliates for any losses or damages that may result from any inaccuracies or incompleteness of the information.</p>

                <p className='font11'> Registration granted by SEBI, membership of BASL and certification from NISM in no way
                  guarantee performance of the intermediary or provide any assurance of returns to investors</p>
                <p className='font11'>Mutual Fund investments are subject to market risks, read all scheme related documents carefully.</p>
                <p className='font11'>Past performance is not indicative of future returns. Please consider your specific investment
                  requirements, risk tolerance, goal, time frame, risk and reward balance and the cost associated with the
                  investment before choosing a fund, or designing a portfolio that suits your needs. Performance and returns
                  of any investment portfolio can neither be predicted<br />
                  nor guaranteed.</p>
                <p className='font11'>SEBI RIA Registration No: INA000013518 | Type of Registration: Non-Individual | Validity of registration:
                  June 19, 2019 - Perpetual | Address: The Summit Business Park, 7th Floor, Unit No. 703, Andheri - Kurla
                  Rd, Behind Guru Nanak Petrol Pump, Opp. PVR Cinema, Andheri East, Mumbai – 400069 | Contact No. 9819022600
                  | Principal Officer details: Nehal Mota, Email : nehal.mota@finnovate.in, Phone: 9152022446 |
                  Corresponding Local SEBI Office : SEBI Office Address: Office of Investor Assistance and Education, SEBI
                  Bhavan Plot No.C4-A, G Block, Bandra Kurla Complex, Bandra (E), Mumbai - 400 051</p>
                <p className='font11'>AMFI Registered Distributor - ARN 52128 | Platform Partner : BSE (Member code 17548) | IRDAI Corporate
                  Agency : CA0703 | CIN: U67190MH2007PTC172272 | GST No : 27AABCF1124C2ZC | Website – <a href="http://www.finnovate.in" target="_blank" rel='noreferrer'>www.finnovate.in</a> Email – <a href="mailto:hello@finnovate.in">hello@finnovate.in</a></p>

              </div>

            </div>
          </>
        )}

      </div>
    </Fragment>
  )
}
